<template>
  <div v-if="!model.$disabled">
    <w-label
      :label-for="dataIds.sid"
      :title="title"
      :show-label="showLabel"
      :model="model"
      :description="description"
      :next-number="nextNumber"
      :bold-label="boldLabel"
      :only-description="onlyDescription"
      :autotext="autotext"
    >
      <template v-slot:description>
        <slot name="description" />
      </template>
    </w-label>

    <label :for="dataIds.sid" class="select" v-bind:class="{'state-error': model.$error, 'state-disabled': isDisabled}">
      <select
        v-if="renderReady"
        ref="input"
        :id="dataIds.sid"
        :value="svalue"
        :disabled="isDisabled"
        :name="model.$form.testPath ? model.$path : undefined"
        :aria-label="activeAria"
        :aria-invalid="isError"
        :aria-describedby="isError ? dataIds.errId : undefined"
        :placeholder="placeholder"
        @input="onInput($event)"
        @change="onInput($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        @mouseover="mouseOver($event)"
        @mouseleave="mouseOut($event)"
      >
        <option v-if="placeholder" disabled="disabled" value :selected="svalue">{{ placeholder }}</option>

        <template v-for="(value, index) in values">
          <option v-if="!value.children" :key="index" :value="value.value" :disabled="value.disabled" :selected="svalue == value.value">{{ value.text }}</option>

          <optgroup v-else :key="index" :label="value.text">
            <option v-for="(child, index2) in value.children" :value="child.value" :disabled="child.disabled" :key="index2" :selected="svalue == value.value">
              {{ child.text }}
            </option>
          </optgroup>
        </template>
      </select>
      <i />
    </label>

    <w-error :model="model" @focus="$refs.input.focus()" :id="dataIds.errId" />
  </div>
</template>

<script>
//         v-tooltip.notrigger="{content: tooltipContent, visible: tooltipVisibility}"

import titleMixin from '../mixins/titleMixin';
import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-select',
  components: {WError, WTooltip},
  mixins: [modelMixin, titleMixin],
  props: {
    values: Array,
    label: {
      type: [String, Boolean],
      default: true
    },
    placeholder: String,
    setTitleAsPlaceholder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    textValue() {
      const ff = this.svalue;
      for (let i = 0; i < this.values.length; i++) {
        const vv = this.values[i];
        if (vv.children) {
          for (let j = 0; j < vv.children.length; j++) {
            if (vv.children[j].value === ff) {
              return vv.children[j].text;
            }
          }
        } else {
          if (vv.value === ff) {
            return vv.text;
          }
        }
      }
      return this.placeholder || '';
    }
  },
  mounted() {
    if (this.setTitleAsPlaceholder) {
      this.placeholder = this.getTitle;
      this.label = false;
    }
  }
};
</script>
